import { Breadcrumb, Tabs, TabsProps } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'

import { HomeOutlined } from '@ant-design/icons';
import { useMemo } from 'react';

import styled from 'styled-components';
import { useGetInsuranceQuery } from '../../../../../api/plamo-api';
import InsuranceMainForm from './insurance-main-form';
import InsuranceAddresses from './insurance-addresses';
import { IconBuildingSolid } from '../../../../../icon';

const TabsStyled = styled(Tabs)`
  flex: 1;

  .ant-tabs-content, .ant-tabs-tabpane {
    height: 100%;
  }
`

function InsuranceDetails() {
  
  const { id, subpage } = useParams();
  const insuranceId = useMemo(() => parseInt(id || "") || undefined, [id])
  const { data: insurance } = useGetInsuranceQuery({ id }, { skip: id === 'new' }) as { data: any }
  
  const navigate = useNavigate();
 
  const tabItems: TabsProps['items'] = [
    {
      key: 'mainForm',
      label: 'Hauptmaske',
      children: <InsuranceMainForm insuranceId={insuranceId} insurance={insurance} />,
    },
    {
      key: 'addresses',
      label: 'Rechnungsadressen',
      children: <InsuranceAddresses insuranceId={insuranceId} />,
      disabled: id === 'new'
    },
  ];

  return (
    <div  style={{ height: "100%", overflow: "scroll", display: 'flex', flexDirection: 'column' }}>
       <Breadcrumb
          style={{ marginBottom: "24px" }}
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined />,
            },
            {
              onClick: () => navigate('/insurance'),
              title: (
                <>
                  <IconBuildingSolid />
                  <span>Versicherungen</span>
                </>
              ),
            },  
            {
              title: `${insurance?.name ?? ''}`
            },            
          ]}
        />
      
        <TabsStyled items={tabItems} activeKey={subpage || 'mainForm'} onChange={newSubpage => { console.log("Navigating to", `${subpage ? '../' : ''}${newSubpage}`); navigate(`/insurance/${id}${newSubpage === 'mainForm' ? '' : `/${newSubpage}`}`)}} />
    </div>
  )
}

export default InsuranceDetails